export default {

    async login(_this) {
        
        await axios.post("api/seguridad/IniciarSesion", _this.loginForm)
            .then((response) => {
                
                if(response.data.Response.Codigo=="01"){
                    toastr["success"](response.data.Response.Mensaje);
                    localStorage.setItem("auth_token", response.data.Data.Token);
                    //console.log(localStorage.getItem("nombreUsuario"));
                    if(response.data.Data.NombreCompleto==null){
                        localStorage.setItem("nombreUsuario", "Saray Salas");
                    }
                    else{
                        localStorage.setItem("nombreUsuario", response.data.Data.NombreCompleto);
                    }
                    _this.$router.push("/user-inicio-usuario").catch(err => {});
                }

                else{
                    toastr["error"](response.data.Response.Mensaje);
                }
                return true;
            })
            .catch((error) => {
                //_this.$router.go(0);
                toastr["error"](error.response.Mensaje);
                return false;
            });
    },

    register(_this) {
        
      return  axios.post("api/seguridad/RegistrarCliente", _this.registerForm)
            .then((response) => {
                if(response.data.Response.Codigo=="01"){
                    toastr["success"](response.data.Response.Mensaje);
                    localStorage.removeItem("auth_token");
                    localStorage.removeItem("nombreUsuario");
                    return true;
                }
                else{
                    toastr["error"](response.data.Response.Mensaje);
                    return response.data.Response.Mensaje;
                }
                
            })
            .catch((error) => {
                toastr["error"](error);
                return false;
            });
    },

    async registerBankClient(_this) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("auth_token");
        await axios.post("api/Operacion/RegistrarBancosCliente", _this.registerForm)
            .then((response) => {
                if(response.data.Response.Codigo=="01"){
                    toastr["success"](response.data.Response.Mensaje);

                    let tipocambio=localStorage.getItem("tipoCambio");
                    let valorE=localStorage.getItem("valorRecibir");
                    let valorR=localStorage.getItem("valorEnviar");

                    if(tipocambio!=null && valorE!=null && valorR!=null){
                        _this.$router.push("/user-inicio-usuario").catch(err => {});
                         //_this.$router.push("/user-completar-datos");
                     }
                    else{
                        _this.$router.push("/user-inicio-usuario").catch(err => {});
                    }
                   }

                else{
                    toastr["error"](response.data.Response.Mensaje);
                }
                return true;
            })
            .catch((error) => {
                if(error.response.status=="401"){
                    this.logoutToken();
                    _this.$router.push("/auth-login").catch(err => {});
                }
                return false;
            });
    },

    async registerBankClientCuenta(_this) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("auth_token");
        await axios.post("api/Operacion/RegistrarBancosCliente", _this.registerForm)
            .then((response) => {
                if(response.data.Response.Codigo=="01"){
                    toastr["success"](response.data.Response.Mensaje);
                       // _this.$router.push("/user-cuentas-usuario").catch(err => {});
                   }

                else{
                    toastr["error"](response.data.Response.Mensaje);
                }
                return true;
            })
            .catch((error) => {
                if(error.response.status=="401"){
                
                    this.logoutToken();
                    _this.$router.push("/auth-login").catch(err => {});
                }
                return false;
            });
    },

    async registerOperation(_this) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("auth_token");
        await axios.post("api/Operacion/RegistrarOperaciones", _this.registerForm)
            .then((response) => {
                if(response.data.Response.Codigo=="01"){
                    toastr["success"](response.data.Response.Mensaje);
                   // _this.$router.push("/user-operaciones-verificando");
                }

                else{
                    toastr["error"](response.data.Response.Mensaje);
                }
                return true;
            })
            .catch((error) => {
                if(error.response.status=="401"){
                
                
                    this.logoutToken();
                    _this.$router.push("/auth-login").catch(err => {});
                }
                return false;
            });
    },

    async recover(_this) {
        
        await axios.post("api/seguridad/EnvioCodigoValidacion", _this.recoverForm)
            .then((response) => {

               if(response.data.Response.Codigo=="01"){
                    localStorage.setItem("mailRec", _this.recoverForm.Correo);
                    toastr["success"](response.data.Response.Mensaje);
                    _this.$router.push("/auth-verificacion").catch(err => {});
                }

                else{
                    toastr["error"](response.data.Response.Mensaje);
                }
                
                return true;
            })
            .catch((error) => {
                toastr["error"](error);
                return false;
            });
    },

    async validate(_this) {
        
        await axios.post("api/seguridad/ValidarCodigoRecuperacion", _this.validateForm)
            .then((response) => {
                if(response.data.Response.Codigo=="01"){
                    toastr["success"](response.data.Response.Mensaje);
                    _this.$router.push("/auth-nueva-contrasena").catch(err => {});
                }

                else{
                    toastr["error"](response.data.Response.Mensaje);
                }
                return true;
            })
            .catch((error) => {
                toastr["error"](error);
                return false;
            });
    },
    async updatepassword(_this) {
        
        await axios.post("api/seguridad/ActualizarContrasenia", _this.newPasswordForm)
            .then((response) => {
                if(response.data.Response.Codigo=="01"){
                    toastr["success"](response.data.Response.Mensaje);
                    _this.$router.push("/auth-login").catch(err => {});
                }

                else{
                    toastr["error"](response.data.Response.Mensaje);
                }
                return true;
            })
            .catch((error) => {
                toastr["error"](error);
                return false;
            });
    },
    listParameters() {
        return  axios.get('api/Parametro/ListarParametrosGenerales').then(response => {
                    return response.data.Data;
        }).catch(error => {
            return error.response.data;
        });
    },

    listBankKallpa(_this,tipoMoK) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("auth_token");
        return  axios.get('api/Operacion/ListaBancosKallpaPorMoneda?idTipoMoneda='+tipoMoK).then(response => {
                    return response.data.Data;
        }).catch(error => {
            if(error.response.status=="401"){
                
                this.logoutToken();
                _this.$router.push("/auth-login").catch(err => {});
            }
            return false;
        });
    },
    async listBankClient(_this,tipoMo) {
       
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("auth_token");
        
        return  axios.get('api/Operacion/ListaBancosClientePorMoneda?idTipoMoneda='+tipoMo).then(response => {
            
                    return response.data.Data;
        }).catch(error => {
            if(error.response.status=="401"){
                
                
                this.logoutToken();
                _this.$router.push("/auth-login").catch(err => {});
            }
            return false;
        });
    },

    listParametersGenerals() {
        
       return  axios.get('api/Parametro/ListarParametrosGenerales').then(response => {
                return response.data.Data.ParametrosGeneralesUbigeo;
            }).catch(error => {
                console.log(error);
                return error.response.data;
            });
    },
    listOperation(_this) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("auth_token");
        return  axios.get('api/Operacion/ListarOperacionCliente').then(response => {
                 return response.data.Data;
             }).catch(error => {
                if(error.response.status=="401"){
                
                
                    this.logoutToken();
                    _this.$router.push("/auth-login").catch(err => {});
                }
                return false;
             });
     },
     obtenerCliente(_this) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("auth_token");
        return  axios.post('api/seguridad/ObtenerCliente').then(response => {
                 return response.data.Data.DatosPersonales;
             }).catch(error => {
                if(error.response.status=="401"){
                
                
                    this.logoutToken();
                    _this.$router.push("/auth-login").catch(err => {});
                }
                return false;
             });
     },
     editarCliente(_this) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("auth_token");
        return  axios.post('api/seguridad/ObtenerCliente').then(response => {
                 return response.data.Data;
             }).catch(error => {
                if(error.response.status=="401"){
                
                
                    this.logoutToken();
                    _this.$router.push("/auth-login").catch(err => {});
                }
                return false;
             });
     },
     async actualizarCliente(_this) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("auth_token");
        await axios.post("api/seguridad/ActualizarCliente", _this.editForm)
            .then((response) => {
               if(response.data.Response.Codigo=="01"){
                    toastr["success"](response.data.Response.Mensaje);
                    _this.$router.push("/user-perfil").catch(err => {});
                }

                else{
                    toastr["error"](response.data.Response.Mensaje);
                }
            })
            .catch((error) => {
                if(error.response.status=="401"){
                
                    this.logoutToken();
                    _this.$router.push("/auth-login").catch(err => {});
                }
                return false;
            });
     },
     listarBancoCliente(_this) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("auth_token");
        return  axios.get('api/Operacion/ListaBancosClientePorMoneda').then(response => {
                    return response.data.Data;
        }).catch(error => {
            if(error.response.status=="401"){
                
                this.logoutToken();
                _this.$router.push("/auth-login").catch(err => {});
            }
            return false;
        });
     },
     obtenerBancoCliente(_this,route) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("auth_token");
        return  axios.get('api/Operacion/ObtenerBancosCliente?idBancoCliente='+route).then(response => {
                    return response.data.Data;
        }).catch(error => {
            if(error.response.status=="401"){
                
                
                this.logoutToken();
                _this.$router.push("/auth-login").catch(err => {});
            }
            return false;
        });
     },
     async actualizarBancoCliente(_this) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("auth_token");
        await axios.post("api/Operacion/ActualizarBancosCliente", _this.registerForm)
        .then((response) => {
            if(response.data.Response.Codigo=="01"){
                 toastr["success"](response.data.Response.Mensaje);
                 _this.$router.push("/user-cuentas-usuario").catch(err => {});
             }

             else{
                 toastr["error"](response.data.Response.Mensaje);
             }
         })
         .catch((error) => {
            if(error.response.status=="401"){
                
                this.logoutToken();
                _this.$router.push("/auth-login").catch(err => {});
            }
            return false;
         });
     },
     async eliminarBancoCliente(route) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("auth_token");
        await axios.delete('api/Operacion/EliminarBancosCliente?idBancoCliente='+route)
        .then((response) => {
            if(response.data.Response.Codigo=="01"){
                 toastr["success"](response.data.Response.Mensaje);
               
             }
             else{
                 toastr["error"](response.data.Response.Mensaje);
             }

         })
         .catch((error) => {
            if(error.response.status=="401"){
                
                this.logoutToken();
                _this.$router.push("/auth-login").catch(err => {});
            }
            return false;
         });
     },
    async cerrarSesion() {
            localStorage.removeItem("ocultarMensajeInicio");
            //localStorage.removeItem('auth_token');
            //axios.defaults.headers.common['Authorization'] = null;
          return true
    },
     
    async logout() {
        return await axios.post('api/auth/logout').then(response => {
            localStorage.removeItem('auth_token');
            axios.defaults.headers.common['Authorization'] = null;
            toastr['success'](response.data.message);
            return true;
        }).catch(error => {
            console.log(error);
            return false;
        });
    },

     logoutToken() {
            localStorage.removeItem('auth_token');
            toastr['error']('Su sesión ha caducado (401)');
            return true;
    },

    check() {
        if(!!localStorage.getItem("auth_token")){
            return true;
        }
        return false;
    },

    authUser() {
        return axios.get('api/auth/user').then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return error.response.data;
        });
    },

    validateTime() { 
        return axios.post('api/parametro/ValidarHorarioAtencion').then(response => {
                 return response.data.Response.Mensaje;
             }).catch(error => {
                 return error.response;
             });
     },
     validateTimeGeneral() { 
        return axios.post('api/parametro/ValidarHorarioAtencionGeneral').then(response => {
                 return response.data.Response.Mensaje;
             }).catch(error => {
                 return error.response;
             });
     },
     async registerClientCupon(_this) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("auth_token");
        await axios.post("api/Operacion/RegistrarCuponCliente", _this.registerCupon)
            .then((response) => {
                if(response.data.Response.Codigo=="01"){
                    //toastr["success"](response.data.Response.Mensaje);         
                }else{
                    //toastr["error"](response.data.Response.Mensaje);
                }
                return true;
            })
            .catch((error) => {
                if(error.response.status=="401"){
                
                    this.logoutToken();
                    _this.$router.push("/auth-login").catch(err => {});
                }
                return false;
            });
    },

    validarCoupon(route) {
        return axios.get('api/parametro/ValidarCupon?codigoCupon='+route).then(response => {
            return response;
        }).catch(error => {
            console.log(error);
            return error.response;
        });
    },

    validarCouponUser(route) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("auth_token");
        return  axios.get('api/Operacion/ValidarCupon?codigoCupon='+route).then(response => {
                 
                 //console.log(response);
                 return response;
             }).catch(error => {
                 console.log(error);
                 return error.response;
             });
     },

     async registerContador(direccion,dispositivo) {
        await axios.post('api/parametro/RegistrarContador?direccion='+direccion+'&dispositivo='+dispositivo).then(response => {
                if(response.data.Response.Codigo=="01"){
                    //toastr["success"](response.d ata.Response.Mensaje);                 
                }
                else{ 
                    //toastr["error"](response.data.Response.Mensaje);
                }
                return true;
            })
            .catch((error) => {
                toastr["error"](error);
                return false;
            });
    },
    
    /*
    messagePromotions() {        
        return axios.post('api/parametro/MensajePromociones').then(response => {
                console.log(response.data.Response.Mensaje);
                 return response.data.Response.Mensaje;
             }).catch(error => {
                 return error.response;
             });
     },

   */
     
}


// WEBPACK FOOTER //
// ./src/services/auth.js